import {Stack, Text, VStack} from 'platform/foundation';

import {suffixTestId, TestIdProps} from 'shared/web';

import i18n from '../../../../../i18n/i18n';
import {FeaturesFilterDialog} from '../../FeaturesFilterField/FeaturesFilterDialog';
import {FeaturesFilterTrigger} from '../../FeaturesFilterField/FeaturesFilterTrigger';

export interface PresetFeaturesFieldBodyProps extends TestIdProps {
  sortedFeatureItems: Array<{key: string; label: string}>;
  draftValue: string[];
  isOpen: boolean;
  isLoading: boolean;
  isReadOnly?: boolean;
  onDraftChange: (value: string[]) => void;
  onOpen: () => void;
  onClose: () => void;
  onConfirm: (value: string[]) => void;
  onChange: (value: string[]) => void;
}

export function PresetFeaturesFieldBody(props: PresetFeaturesFieldBodyProps) {
  const {
    sortedFeatureItems,
    draftValue,
    isOpen,
    isLoading,
    isReadOnly,
    onDraftChange,
    onOpen,
    onClose,
    onConfirm,
    onChange,
  } = props;

  return (
    <VStack spacing={1}>
      <Stack
        direction={['column', 'row']}
        align={[undefined, 'center']}
        justify="space-between"
        spacing={2}
      >
        <Text size="small" data-testid={suffixTestId('label', props)}>
          {i18n.t('entity.filterForm.features')}
        </Text>
        <FeaturesFilterTrigger
          items={sortedFeatureItems}
          onOpen={onOpen}
          onChange={onChange}
          isDisabled={isLoading || isReadOnly}
          isLoading={isLoading}
          data-testid={suffixTestId('featuresFilterTrigger', props)}
        />
      </Stack>
      <FeaturesFilterDialog
        isOpen={isOpen}
        draftValue={draftValue}
        onDraftChange={onDraftChange}
        isLoading={isLoading}
        onClose={onClose}
        onConfirm={onConfirm}
        data-testid={suffixTestId('dialog', props)}
      />
    </VStack>
  );
}
